export default {
  state: {
    url: "",
    argumentos: {},
    API: ""
  },
  actions: {
    CriarUrl({ commit, state }, args) {
      state.argumentos = args;

      commit("ConfigurarUrl", args.adicionarUrls ? args.adicionarUrls : {});
      commit("ConfigurarOptions");

      return state.url;
    }
  },
  mutations: {
    setAPI(state, _api) {
      state.API = _api;
    },
    ConfigurarUrl(state, { adicionarApi = true, adicionarAuth = false }) {
      state.url = `${state.API}`;

      if (state.url.charAt(state.url.length - 1) !== "/") {
        state.url += "/";
      }

      if (adicionarAuth) {
        state.url += "auth/";
      } else if (adicionarApi) {
        state.url += "api/";
      }

      if (state.argumentos.resource.charAt(0) === "/") {
        state.argumentos.resource = state.argumentos.resource.substring(1);
      }

      state.url += state.argumentos.resource;
    },

    ConfigurarOptions(state) {
      var params = "";

      for (const key in state.argumentos.params) {
        if (key in state.argumentos.params) {
          const item = state.argumentos.params[key];

          params += "&" + key + "=" + item;
        }
      }

      if (params != "") {
        if (params.charAt(0) === "&") {
          params = params.substring(1);
        }

        if (state.url.indexOf("?") === -1) {
          state.url += "?";
        }

        state.url += params;
      }
    }
  },
  getters: {
    getUrlApi: state => state.API
  }
};
